import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';

const TenantPercentage = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikInput
      placeholder="Enter tenant percentage"
      id="tenantPercentage"
      name="tenantPercentage"
      label="Tenant Percentage"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default TenantPercentage;
